const MarqueeColumn = ({ images, duration, reverse }) => (
  <div className="relative h-full overflow-hidden">
    <div
      className={`flex flex-col gap-4 ${reverse ? "animate-marquee-down" : "animate-marquee-up"}`}
      style={{ animationDuration: `${duration}s` }}
    >
      {[...images, ...images].map((src, i) => (
        <img
          key={i}
          src={src}
          alt=""
          aria-hidden="true"
          className="h-40 w-full flex-shrink-0 rounded-2xl object-cover sm:h-48"
          loading="lazy"
        />
      ))}
    </div>
  </div>
);

export default MarqueeColumn;
